import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '../../assets/arrow-right.png';
const _hoisted_1 = { class: "document-info" };
const _hoisted_2 = { class: "company" };
const _hoisted_3 = { class: "file-name" };
const _hoisted_4 = { class: "date" };
const _hoisted_5 = { class: "document-type" };
export default /*@__PURE__*/ _defineComponent({
    __name: 'DocumentListItem',
    props: {
        company: { default: '' },
        fileName: { default: '' },
        date: { default: '' },
        documentType: { default: '' },
        datePrefix: { default: 'Added' }
    },
    emits: ["click"],
    setup(__props, { emit: __emit }) {
        const emit = __emit;
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: "document-list-item",
                onClick: _cache[0] || (_cache[0] = ($event) => (emit('click')))
            }, [
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.company), 1),
                    _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.fileName), 1),
                    _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.datePrefix) + " " + _toDisplayString(_ctx.date), 1),
                    _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.documentType), 1)
                ]),
                _cache[1] || (_cache[1] = _createElementVNode("div", { class: "arrow-icon" }, [
                    _createElementVNode("img", {
                        class: "arrow",
                        src: _imports_0
                    })
                ], -1))
            ]));
        };
    }
});
